import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiProduto = {
    fetchApi: async (page) => {
        const URL = `${apiLink()}api/produto?page=` + page;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    fetchApiCondensacao: async (page) => {
        const URL = `${apiLink()}api/condensacao?page=` + page;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    getById: async (id) => {
        const URL = `${apiLink()}api/produto/` + id;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    postApi: async (produto) => {
        const URL = `${apiLink()}api/produto`;
        return await axiosInstance.post(URL, produto)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao fazer o post dos dados:', error);
                throw new Error(error.message);

            })
    },
    postApiCondensacao: async (produto) => {
        const URL = `${apiLink()}api/condensacao`;
        return await axiosInstance.post(URL, produto)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao fazer o post dos dados:', error);
                throw new Error(error.message);

            })
    },
    putApi: async (id, produto) => {
        const URL = `${apiLink()}api/produto/${id}`;
        return await axiosInstance.put(URL, produto)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao fazer o post dos dados:', error);
                throw new Error(error.message);

            })
    },
    putApiCondensacao: async (id, produto) => {
        const URL = `${apiLink()}api/condensacao/${id}`;
        return await axiosInstance.put(URL, produto)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao fazer o post dos dados:', error);
                throw new Error(error.message);

            })
    },
    deleteApi: async (id) => {
        const URL = `${apiLink()}api/produto/status/${id}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao deletar o produto:', error);
            })
    },    
    getByUnidadeId: async (id) => {
        const URL = `${apiLink()}api/produto/all`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar produto:', error);
                throw new Error('Erro ao pegar produto:', error);
            })
    },
    getEquipamentoComUltimasLeituras: async (equipamentoId, numLeituras) => {
        const URL = `${apiLink()}api/produto/${equipamentoId}/numero-leituras/${numLeituras}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar produto:', error);
                throw new Error('Erro ao pegar produto:', error);
            })
    },
    getChartProdutos: async (unidadeId, periodo) => {
        const URL = `${apiLink()}api/produto/periodo`;
        return await axiosInstance.post(URL, periodo)
            .then((res) => res)
            .catch(error => {
                throw new Error('Erro ao pegar produto:', error);
            })

    }
}

export default apiProduto; 


